import React from "react";
import MyMap from "./Js/MyMap";
import Footer from "./Js/Footer";

const App = () => {
  return (
    <>
      <MyMap />
      <Footer />
    </>
  );
};

export default App;
